import { SxProps } from '@mui/material';

export const textFieldStyles: SxProps = {
  backgroundColor: 'primary.contrastText',
};

export const selectFieldStyles: SxProps = {
  backgroundColor: 'primary.contrastText',
};
